module.exports = __webpack_public_path__ + "img/2026-03-24c_3.d1502d93.jpg";